import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {MsalService  } from '@azure/msal-angular';
import { request } from 'https';

@Component({
  selector: 'app-login-internal',
  templateUrl: './login-internal.component.html',
  styleUrls: ['./login-internal.component.css']
})
export class LoginInternalComponent implements OnInit {

  constructor(private msalService: MsalService, private router: Router) { }

  ngOnInit(): void {

    if (!this.msalService.instance.getActiveAccount()) {
      this.msalService.loginRedirect();
      this.router.navigateByUrl('/home');
    } else {
      this.router.navigateByUrl('/home');
    }
  }
}
